import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import "./../../../../assets/css/general/Homelayout/MentorShowcase/MentorsShowcase.css";

const MentorShowcase = () => {
  const navigate = useNavigate();
  const [expandedMentor, setExpandedMentor] = useState(null);

  const mentors = [
    {
      id: 1,
      name: "Sarah Chen",
      role: "Senior Frontend Engineer",
      background: "Startup & SaaS",
      focus: "Building production-ready React applications",
      credibility: "8 years experience",
      helpText:
        "Guides you through real-world frontend architecture, component design patterns, and industry best practices learned from scaling applications at high-growth startups.",
      bestFor: "Career switchers & Intermediate learners",
      photo: "SC",
    },
    {
      id: 2,
      name: "Marcus Rodriguez",
      role: "Tech Lead",
      background: "Enterprise & Cloud",
      focus: "System design and scalable architecture",
      credibility: "12 years experience",
      helpText:
        "Teaches you how to think like a senior engineer—breaking down complex systems, making architectural decisions, and understanding trade-offs that matter in production.",
      bestFor: "Intermediate & Advanced learners",
      photo: "MR",
    },
    {
      id: 3,
      name: "Priya Sharma",
      role: "Full Stack Developer",
      background: "Agency & Product",
      focus: "From zero to first developer job",
      credibility: "Helped 200+ learners transition",
      helpText:
        "Specializes in career transitions—helping beginners build confidence, create portfolio projects, and land their first tech role through practical, job-focused guidance.",
      bestFor: "Beginners & Career switchers",
      photo: "PS",
    },
  ];

  const handleCardClick = (mentorId) => {
    setExpandedMentor(expandedMentor === mentorId ? null : mentorId);
  };

  return (
    <section className="msc-mentor-showcase">
      <Container className="msc-mentor-container">
        <Row>
          <Col xs={12}>
            <div className="msc-mentor-framing">
              <h2 className="msc-mentor-headline">
                Learn from people who've already walked the path.
              </h2>
              <p className="msc-mentor-subtext">
                Our mentors are industry professionals who provide real-world
                guidance based on years of hands-on experience—not generic
                advice.
              </p>
            </div>
          </Col>
        </Row>

        <Row className="msc-mentor-grid g-4">
          {mentors.map((mentor) => (
            <Col key={mentor.id} xs={12} lg={4}>
              <div
                className={`msc-mentor-card ${
                  expandedMentor === mentor.id
                    ? "msc-mentor-card--expanded"
                    : ""
                }`}
                onClick={() => handleCardClick(mentor.id)}
                role="button"
                tabIndex={0}
                onKeyPress={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    handleCardClick(mentor.id);
                  }
                }}
              >
                <div className="msc-mentor-card-content">
                  <div className="msc-mentor-photo">
                    <span className="msc-mentor-initials">{mentor.photo}</span>
                  </div>

                  <h3 className="msc-mentor-name">{mentor.name}</h3>

                  <p className="msc-mentor-role">
                    {mentor.role}{" "}
                    <span className="msc-mentor-separator">•</span>{" "}
                    {mentor.background}
                  </p>

                  <p className="msc-mentor-focus">{mentor.focus}</p>

                  <div className="msc-mentor-credibility">
                    {mentor.credibility}
                  </div>

                  {expandedMentor === mentor.id && (
                    <div className="msc-mentor-details">
                      <div className="msc-mentor-help">
                        <h4 className="msc-mentor-help-title">
                          How this mentor helps
                        </h4>
                        <p className="msc-mentor-help-text">
                          {mentor.helpText}
                        </p>
                      </div>
                      <div className="msc-mentor-best-for">
                        <span className="msc-mentor-label">Best for:</span>
                        <span className="msc-mentor-audience">
                          {mentor.bestFor}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </Col>
          ))}
        </Row>

        <Row>
          <Col xs={12}>
            <div className="msc-mentor-cta-wrapper">
              <button
                onClick={() => navigate("/mentor-wizard")}
                className="msc-mentor-cta"
              >
                Find the right mentor for me →
              </button>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default MentorShowcase;
